import BlokWrap from "@/components/atoms/BlokWrap";
import getLink from "@/lib/storyblok/utils/getLink";
import type { FeaturedItemStoryblok } from "@/types/storyblok-blok-types";
import { type SbBlokData, storyblokEditable } from "@storyblok/react/rsc";
import Image from "next/image";
import Link from "next/link";
import styles from "./FeaturedItem.module.css";

export interface FeaturedItemBlokProps {
  blok: FeaturedItemStoryblok;
  preview: boolean;
}

export const FeaturedItemBlok = ({ blok }: FeaturedItemBlokProps) => {
  const link = blok.link?.at(0);

  return (
    <BlokWrap
      {...storyblokEditable(blok as unknown as SbBlokData)}
      animated=""
      className={styles.root}
    >
      <Image
        sizes={`(max-width: 1024px) 70vw, (max-width: 2560px) 50vw`}
        src={blok.media?.filename || ""}
        alt={blok.media?.alt || ""}
        fill
      />
      <div className={styles.content}>
        <p className={styles.title}>{blok.title}</p>

        {link && (
          <Link className={styles.link} href={getLink(link.link) || ""}>
            {link.text}
          </Link>
        )}
      </div>
    </BlokWrap>
  );
};
